export enum XboxNetworkFeatures {
  xboxPlayAnywhere = "xboxPlayAnywhere",
  crossOwnership = "crossOwnership",
  crossSave = "crossSave",
  crossProgression = "crossProgression",
  sharedAchievements = "sharedAchievements",
  smartDelivery = "smartDelivery",
}
